import React from "react"

interface DateInputProps {
  value: string
  setValue: (value: string) => void
  placeholder: string
}

const DateInput: React.FC<DateInputProps> = ({ value, setValue, placeholder }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
  }

  return (
    <div className="relative w-full rounded-2xl">
      <input
        id={placeholder}
        type="date"
        value={value}
        onChange={handleChange}
        className={
          "form-input bg-gray-100 rounded-2xl pt-6 pb-2 mb-1 w-full focus:ring-0 focus:outline-none transition-all duration-200 peer"
        }
      />
      <label
        htmlFor={placeholder}
        className={`absolute left-4  transition-all duration-200 transform pointer-events-none ${
          value ? "top-1 text-xs text-gray-600" : "top-2 text-base text-gray-400"
        } peer-focus:top-1 peer-focus:text-xs peer-focus:text-gray-600`}
      >
        {placeholder}
      </label>
    </div>
  )
}

export default DateInput
